// Shared layout constants
export const LAYOUT_CONSTANTS = {
  TOP_NAV_HEIGHT: 75, // px
} as const
